module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-book-panel",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "callout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Booking Mode"), _c('BookingModeSelect', {
    attrs: {
      "disabled": _vm.hideSearchFields
    },
    model: {
      value: (_vm.booking_mode),
      callback: function($$v) {
        _vm.booking_mode = $$v
      },
      expression: "booking_mode"
    }
  })], 1)]), (!_vm.driverId) ? _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Driver")]), _c('SearchEntity', {
    attrs: {
      "entity": "drivers",
      "loadedValues": _vm.entityDrivers
    },
    model: {
      value: (_vm.book.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.book, "driver_id", $$v)
      },
      expression: "book.driver_id"
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Vehicle"), _c('selectize-vehicle', {
    attrs: {
      "disabledSlot": 0
    },
    on: {
      "optionSelected": _vm.setVehicle,
      "optionRemoved": _vm.unsetVehicle
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Driver position"), _c('GoogleMapSearchBox', {
    on: {
      "placesChanged": _vm.setDriverPosition
    }
  })], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('label', [_vm._v("Memo"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.memo),
      expression: "book.memo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "memo", $event.target.value)
      }
    }
  })])])]), _c('h2', [_vm._v("Extra costs")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Costs")]), _c('selectize-common-cost', {
    attrs: {
      "maxItems": null
    },
    on: {
      "optionSelected": _vm.addCommonCost,
      "optionRemoved": _vm.removeCommonCost
    }
  })], 1)]), (['RT', 'CRT', 'SRT', 'STR'].includes(_vm.booking_mode) && !_vm.hideSearchFields) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initialDate": _vm.bookStart,
      "disabledFrom": _vm.disabledFrom,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("End"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initialDate": _vm.end,
      "disabledFrom": _vm.disabledFrom,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)])]) : _vm._e(), (!_vm.hideSearchFields) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSearchButton
    },
    on: {
      "click": _vm.dataLoader
    }
  }, [_vm._v("Search vehicle")])])]) : _vm._e(), (!_vm.hideSearchFields) ? _c('div', {
    staticClass: "search-results"
  }, [(_vm.loading) ? _c('loading-spinner') : (_vm.vehicleLength > 0) ? _c('tab-headers', {
    attrs: {
      "tabs": ['Vehicles Map', 'Vehicles List'],
      "id": 'book-vehicle',
      "activeIndex": 0
    }
  }, [_c('tab-content', {
    attrs: {
      "headerName": 'Vehicles Map',
      "active": true
    }
  }, [_c('book-vehicle-from-map', {
    attrs: {
      "vehicles": _vm.vehicles,
      "userPosition": _vm.getUserPosition
    },
    on: {
      "getVehicleSelected": _vm.bookNow
    }
  })], 1), _c('tab-content', {
    attrs: {
      "headerName": 'Vehicles List',
      "active": true
    }
  }, _vm._l((_vm.slotsByLots), function(slots, key) {
    return _c('div', {
      staticClass: "grouped card",
      style: (_vm.gridStyle(slots))
    }, [_c('h1', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(key))]), _vm._l((slots), function(vehicle, id) {
      return (!vehicle.disabled) ? _c('vehicle', {
        key: id,
        attrs: {
          "item": vehicle,
          "type": "search-result"
        },
        on: {
          "bookVehicle": _vm.bookNow
        }
      }) : _vm._e()
    })], 2)
  }), 0)], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "availability"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initialDate": _vm.start,
      "disabledFrom": _vm.disabledFrom,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("End"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "initialDate": _vm.end,
      "disabledFrom": _vm.disabledFrom,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)])]), _c('div', {
    staticClass: "row columns"
  }, [(_vm.book.driver_id && !_vm.bookDirectlyHide) ? _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.end
    },
    on: {
      "click": _vm.bookFast
    }
  }, [_vm._v("Book")]) : _vm._e()]), _c('div', {
    staticClass: "row columns"
  }), (_vm.availability.length && !_vm.bookDirectly) ? _c('backoffice-vehicle-availability', {
    attrs: {
      "availability": _vm.availability
    },
    on: {
      "slotsSelected": _vm.setDatesAndBook,
      "loadExtra": _vm.showExtraDay,
      "rangeSelection": _vm.rangeSelection
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-112c7afe!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/BookPanel.vue
// module id = 2147
// module chunks = 1